import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const usePattern = () => {
  const country = useSelector(select.account.getCountry);
  const license = useSelector(select.account.getLicense);
  const licenseName = LicenceId[license];

  const isEsCitizenOrResident = useSelector(select.account.isEsCitizenOrResident);
  const isAmlDepositThresholdReached = useSelector(select.account.amlDepositThresholdReached);

  const appendAML = isAmlDepositThresholdReached;
  const appendPoA = license === LicenceId.SPAIN && !isEsCitizenOrResident;

  const pattern = useMemo(() => {
    switch (true) {
      case appendAML:
        return `SW-Web-${licenseName}-AML`;
      case appendPoA:
        return `SW-Web-${licenseName}-PoA`;
      default:
        return `SW-Web-${licenseName}`;
    }
  }, [appendAML, appendPoA, licenseName]);

  const patternWithCountry = useMemo(() => {
    switch (true) {
      case appendAML:
        return `SW-Web-${licenseName}-${country}-AML`;
      case appendPoA:
        return `SW-Web-${licenseName}-${country}-PoA`;
      default:
        return `SW-Web-${licenseName}-${country}`;
    }
  }, [appendAML, appendPoA, country, licenseName]);

  return {
    pattern,
    patternWithCountry,
    defaultPattern: `SW-Web-Default`
  };
};

export default usePattern;
